<template>
  <transition name="order-checkout">
    <div class="mask" v-if="visible">
      <div class="mask_content tax-tips-mask">
        <div class="container">
          <div class="text-content">
            <div class="head">
              <div class="title bold">
                {{ $t('title.kindTips') }}
              </div>
            </div>
            <div class="content common-gray-content">
              {{ $t('tax.tips') }}
            </div>
          </div>
          <div class="footer">
            <div class="button" @click="$emit('confirm')">{{ $t('game.okbtn') }}</div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
// import导入组件工具等
export default {
  data() {
    return {
      visible: false,
    }
  },
  created() {
    this.$nextTick(() => {
      this.visible = true
    })
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.mask {
  background-color: transparent;
  pointer-events: none;
  z-index: 90;
}
.mask_content {
  pointer-events: auto;
  position: absolute;
  height: auto;
  background: #fff;
  padding: 0px 12px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  /* 或 scroll */
  -ms-overflow-style: none;
  /* IE 和 Edge */
  scrollbar-width: none;
  transition: all 0.2s;
  box-shadow:
    0px -6px 46px 0px #0000000f,
    0px -12px 24px 0px #0000001a;
  max-height: calc(100% - 50px);
  width: 100%;
  border-radius: 16px 16px 0 0;
  bottom: 0;
  right: 0;
  transform: none;
  overflow: auto;

  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 52px;
    position: relative;
    .title {
      text-align: center;
      width: 100%;
      font-size: 19px;
      color: #000;
    }
  }

  .content {
    font-size: 14px;
    line-height: 1.2;
    color: #62676b;
    font-weight: 400;
    p {
      padding-bottom: 20px;
    }
  }

  .footer {
    padding: 16px 0;
  }
}
@media (min-width: 1025px) {
  .mask_content {
    padding: 0;
    .container {
      min-height: 80px;
      width: 100%;
      max-width: 912px;
      padding: 8px 14px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .head {
        height: auto;
        .title {
          width: 100%;
          font-size: 16px;
          color: #000;
          text-align: left;
        }
      }
      .content {
        margin-top: 4px;
        background-color: transparent;
        padding: 0;
        font-size: 13px;
        line-height: 1.2;
      }
      .footer {
        padding: 0;
        margin-left: 46px;
        .button {
          min-width: 120px;
        }
      }
    }
  }
}
</style>
